/** Browser only: renders the instruction page and mark glyphs. */

import { POSTER_PRINT_SHEET } from "../../canvas-kit/export/poster.js";
import { loadPosterPdfAssets } from "../../canvas-kit/export/poster-assets.js";
import {
  type PosterPlan,
  planPoster,
  posterAssemblyInfo,
  type ResolvedPosterSize,
} from "../../canvas-kit/export/poster-grid.js";
import {
  buildPosterPdf,
  isPositiveFinite,
  PosterInputError,
  type PosterPdfSource,
} from "../../canvas-kit/export/poster-pdf.js";

export async function exportMediaPoster(args: {
  source: PosterPdfSource;
  size: ResolvedPosterSize;
}): Promise<Uint8Array> {
  const { source, size } = args;
  if (!isPositiveFinite(size.wMm) || !isPositiveFinite(size.hMm)) {
    throw new PosterInputError("Ungültige Postergröße.");
  }
  const plan: PosterPlan = planPoster({ posterWMm: size.wMm, posterHMm: size.hMm });
  const info = posterAssemblyInfo(plan, size);
  const assets = await loadPosterPdfAssets(info, POSTER_PRINT_SHEET, plan.grid.sheetOrientation);
  return buildPosterPdf({ source, plan, assets });
}
